export const defaultFormatTimeZone = {
  format: 'yyyy-MM-d',
  time_zone: '-03:00'
}

export const defaultFormatMonthTimeZone = {
  format: 'yyyy-M',
  time_zone: '-03:00'
}

export const defaultDateRange = {
  initialDate: 'now-15d/d',
  finalDate: 'now/d',
  ...defaultFormatTimeZone
}
